import React, { FC } from "react";
import { ArrowRight } from "@yleisradio/yds-icons-react";
import styled from "styled-components";

import { useEmbedParametersContext } from "../../contexts/EmbedParametersContext";
import { getAreenaUrl } from "../../helpers/areenaLinks";
import { useThemeColors } from "../../hooks/useThemeColors/useThemeColors";
import i18n from "../../service/i18n";
import { usePlayerStore } from "../../store/usePlayerStore";
import { buttonStyle, fontFamily } from "../../styles/global";

// This could be combined with NotAllowedButtonVideo, if common styles are refactored

const Link = styled.a<{
  backgroundColor: string;
  color: string;
  hoverColor: string;
}>`
  align-items: center;
  background-color: ${props => props.backgroundColor};
  border-radius: 26px;
  color: ${props => props.color};
  display: flex;
  font-weight: bold;
  justify-content: space-around;
  min-height: 40px;
  position: relative;
  text-decoration: none;

  span {
    display: block;
    margin-left: 25px;
    margin-right: 10px;
  }

  svg {
    margin-left: 3px;
    margin-right: 17px;
  }

  &:hover {
    span,
    svg {
      opacity: 0.9;
    }
  }

  ${fontFamily}
  ${buttonStyle}
`;

const LinkContainer = styled.div`
  display: flex;
`;

export const NotAllowedButtonAudio: FC = () => {
  const { useStoreState } = usePlayerStore();
  const programId = useStoreState.programId();
  const isSimulcast = useStoreState.isSimulcast();
  const { language, theme } = useEmbedParametersContext();

  const { baseColor, fillColor, hoverColor } = useThemeColors(theme);

  return (
    programId && (
      <LinkContainer>
        <Link
          aria-label={i18n("linkki_yle_areenaan", { language })}
          backgroundColor={fillColor}
          color={baseColor}
          hoverColor={hoverColor}
          href={getAreenaUrl({
            isSimulcast,
            language,
            programId
          })}>
          <span>{i18n("kuuntele_yle_areenassa", { language })}</span>
          <ArrowRight color={baseColor} />
        </Link>
      </LinkContainer>
    )
  );
};
